import { createTranslations } from '../../../shared/config/i18n';

export const translations = createTranslations({
  pageTitle: {
    id: 'password-reset-page-title',
    defaultMessage: 'Reset your password.',
  },
  pageSubtitle: {
    id: 'password-reset-page-subtitle',
    defaultMessage:
      'Enter your registered email address below and we will send you a link to update your password.',
  },
  pageLeftTitle: {
    id: 'password-reset-page-left-title',
    defaultMessage: 'Order by midnight.\nSamples tomorrow.',
  },
  emailPlaceholder: {
    id: 'password-reset-page-email-placeholder',
    defaultMessage: 'Business email',
  },
});
